import React, {Fragment} from "react";
import Navs from './compontents/Navs/Navs';
import Home from './compontents/Home/Home';
import Footer from './compontents/Footer/Footer';


function App() {
  return (
    <Fragment>
    <Navs />
    <Home />
    <Footer />
    </Fragment>
  );
}

export default App;